import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getTasksState = createFeatureSelector<State>('task');

export const getTasks = createSelector(getTasksState,
  (state: State) => state.tasks);

export const getSelectedTask = createSelector(getTasksState,
  (state: State) => state.selectedTask);

export const getAllowAddTask = createSelector(getTasksState,
  (state: State) => state.allowAddTask);
